<template>
  <v-card>
    <v-card-text>
      <h1 class="host-dashboard-title">Host Profile Settings</h1>
      <v-layout row wrap>
        <v-flex xs12 class="pa-3">
          <v-card>
            <v-card-title>
              <h4>Host Bio</h4>
            </v-card-title>
            <v-card-text>
              <div v-if="!editBio">
                <div v-html="newlines(getHost.description)"></div>
                <a @click="editBio=true">Edit Bio</a>
              </div>
              <div v-else>
                <v-textarea v-model="host.bio"></v-textarea>
                <v-btn @click="editBio=false">Cancel</v-btn>
                <v-btn color="success" @click="updateBio">Submit</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import {mapActions, mapGetters} from 'vuex'

import { replaceNewlines } from '~/store/util/util'

export default {
  name: 'host_dashboard_upcoming_events',
  data () {
    return {
      host: {
        bio: ''
      },
      editBio: false
    }
  },
  watch: {
    editBio (newVal, oldVal) {
      if (newVal) {
        this.host.bio = this.getHost.description
      }
    }
  },
  methods: {
    ...mapActions([
      'setHostProp'
    ]),
    updateBio() {
      axios.put('/api/v1/hostrequest/'+this.getHost.uuid+'/', {
        user: this.user.pk,
        description: this.host.bio
      })
      .then((response) => {
        this.setHostProp({
          prop: 'description',
          value: response.data.description
        })
        this.editBio = false
      })
      .catch((error) => {
        console.error(error)
      })
    },
    newlines(value) {
			return replaceNewlines(value)
		},
  },
  computed: {
    ...mapGetters([
      'user',
      'getHost',
    ])
  }
}
</script>

<style>

</style>
